import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function TabNav({ active, onChange, accentColor, contentColor, secondaryBackground, t }) {
    const text = contentColor || "#e2e8f0";
    const bg = secondaryBackground || "#ffffff";
    const activeBg = accentColor || "#1f2937";
    const items = [
        {
            key: "home",
            label: t("tab.home"),
            icon: (_jsxs("svg", { width: "18", height: "18", viewBox: "0 0 24 24", fill: "none", "aria-hidden": true, children: [_jsx("path", { d: "M3 10.5L12 3l9 7.5", stroke: "currentColor", strokeWidth: "1.8", strokeLinecap: "round", strokeLinejoin: "round" }), _jsx("path", { d: "M6 9.5V20h12V9.5", stroke: "currentColor", strokeWidth: "1.8", strokeLinecap: "round", strokeLinejoin: "round" })] })),
        },
        {
            key: "history",
            label: t("tab.history"),
            icon: (_jsxs("svg", { width: "18", height: "18", viewBox: "0 0 24 24", fill: "none", "aria-hidden": true, children: [_jsx("path", { d: "M3 12a9 9 0 1 0 2.64-6.36L3 8", stroke: "currentColor", strokeWidth: "1.8", strokeLinecap: "round", strokeLinejoin: "round" }), _jsx("path", { d: "M3 3v5h5", stroke: "currentColor", strokeWidth: "1.8", strokeLinecap: "round", strokeLinejoin: "round" }), _jsx("path", { d: "M12 7v5l3 2", stroke: "currentColor", strokeWidth: "1.8", strokeLinecap: "round", strokeLinejoin: "round" })] })),
        },
        {
            key: "help",
            label: t("tab.help"),
            icon: (_jsxs("svg", { width: "18", height: "18", viewBox: "0 0 24 24", fill: "none", "aria-hidden": true, children: [_jsx("path", { d: "M9.1 9a2.9 2.9 0 1 1 4.95 2.06c-.73.73-1.32 1.24-1.32 2.44", stroke: "currentColor", strokeWidth: "1.8", strokeLinecap: "round", strokeLinejoin: "round" }), _jsx("circle", { cx: "12", cy: "17", r: "1", fill: "currentColor" }), _jsx("circle", { cx: "12", cy: "12", r: "9", stroke: "currentColor", strokeWidth: "1.8" })] })),
        },
    ];
    return (_jsx("nav", { style: {
            display: "grid",
            gridTemplateColumns: "repeat(3, 1fr)",
            borderTop: "none",
            background: bg,
        }, children: items.map((item) => (_jsxs("div", { role: "button", tabIndex: 0, onClick: () => onChange(item.key), onKeyDown: (e) => {
                if (e.key === "Enter" || e.key === " ")
                    onChange(item.key);
            }, style: {
                padding: "10px 6px",
                display: "grid",
                gap: 4,
                justifyItems: "center",
                alignItems: "center",
                background: active === item.key ? activeBg : bg,
                color: active === item.key ? "#ffffff" : text,
                cursor: "pointer",
                fontSize: 13,
                fontWeight: active === item.key ? 900 : 400,
                transition: "background 0.2s ease, color 0.2s ease",
                outline: "none",
            }, children: [_jsx("span", { "aria-hidden": true, children: item.icon }), _jsx("span", { style: { fontSize: 12 }, children: item.label })] }, item.key))) }));
}
